function formatApiDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value ?? ""));
  return match ? `${match[3]}/${match[2]}/${match[1]}` : String(value ?? "");
}

function toApiChoice(value) {
  if (value === "sim") return "Sim";
  if (value === "nao") return "Não";
  return "";
}

function toApiBedPreference(value) {
  if (value === "casal") return "1 casal";
  if (value === "duas") return "2 camas";
  return "";
}

function onlyDigits(value) {
  return String(value ?? "").replace(/\D/g, "");
}

function appendField(payload, name, value) {
  if (value === undefined || value === null || value === "") return;
  payload.append(`form_fields[${name}]`, String(value));
}

export function buildRegistrationPayload(data) {
  const payload = new URLSearchParams();

  appendField(payload, "ibmposto", data.ibm);
  appendField(payload, "name", data.name);
  appendField(payload, "sobrenome", data.surname);
  appendField(payload, "nomecracha", data.name);
  appendField(payload, "numerocpf", data.cpf);
  appendField(payload, "nascimento", formatApiDate(data.birthDate));
  appendField(payload, "email", data.email);
  appendField(payload, "celular", onlyDigits(data.phone));
  appendField(payload, "necessidades", toApiChoice(data.hasSpecialNeeds));
  appendField(payload, "qualnecessidade", data.specialNeedsDetails);
  appendField(payload, "planosaude", toApiChoice(data.hasHealthPlan));
  appendField(payload, "qualplano", data.healthPlanName);
  appendField(payload, "acompanhante", toApiChoice(data.companion));
  appendField(payload, "nomeacompanhante", data.companionName);
  appendField(payload, "sobrenomeacompanhante", data.companionSurname);
  appendField(payload, "nascimentoacompanhante", formatApiDate(data.companionBirthDate));
  appendField(payload, "cpfacompanhante", data.companionCpf);
  appendField(payload, "cidadeorigem", data.originCity);
  appendField(payload, "horarioprevisto", data.arrivalTime);
  appendField(payload, "camas", toApiBedPreference(data.bedPreference));
  appendField(payload, "alimentos", toApiChoice(data.dietaryRestrictions));
  appendField(payload, "qualalimento", data.dietaryDetails);

  if (data.hasAccessibilityNeeds === "sim" && data.accessibilityDetails) {
    payload.append("form_fields[especiais][]", data.accessibilityDetails);
  }

  if (data.acceptPrivacy) appendField(payload, "declaro", "on");
  appendField(payload, "presenca", "Sim");

  return payload;
}
